import { Box } from '@mui/material';
import Footer from 'components/layout/main/Footer';
import TopBar from 'components/layout/main/TopBar';
import { Outlet, Link as RouterLink } from 'react-router-dom';
/**
 * MainLayout envuelve la estructura pública principal de NOUVA Capilar.
 * Garantiza que el Footer se mantenga siempre al final de la pantalla (Sticky Footer).
 *
 * @param {Object} props
 */
export default function MainLayout() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Ocupa al menos el 100% del alto de la ventana
        backgroundColor: 'background.default',
      }}
    >
      {/* 1. Header Fijo con Navegación y Logo */}
      <TopBar />

      {/* 2. Contenido Principal Dinámico */}
      <Box
        component="main"
        sx={{
          flexGrow: 1, // Absorbe todo el espacio disponible empujando el Footer hacia abajo
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Outlet />
      </Box>

      {/* 3. Pie de página de 4 columnas */}
      <Footer />
    </Box>
  );
}